import React from 'react';
import tecno from '../../Tecno-list/tecno';
import { Link } from 'react-router-dom';

function OldWebUno() {

    return (
        <React.Fragment>
            <section className='Proyect'>

                <h2 className="">Old Porfolio v1.0</h2>
                <div className='folder-porfolio'>

                    <div className="imageProyect imageOldporfolio"></div>
                    
                    <div className="list" >

                        {tecno.filter(tec => tec.T === 'React' || tec.T === 'HTML' || tec.T === 'CSS').map(tec => (

                            <div key={tec.T}>

                                <a href={tec.L} target="_blank" rel="noreferrer">

                                    <button className="etiqueta">  <p> <span>&#183;</span> {tec.T}</p></button>
                                </a>
                            </div>

                        ))}
                    </div>

                    <p className='white'>
                        Old version of my portfolio, I wanted it to have a simple design,
                        but I decided to change the design for a simple but more animated one with some improvements.
                    </p>

                    <a href="https://brandongrimaldom.github.io/" target="_blank" rel="noreferrer">
                        <button className="Git"> <p>Repository </p> <div className="gitIcon"></div> </button>
                    </a>
                </div>
                <div className='after'>
                    <Link to="/old-web-pages" className="Link">  <div className='iconAfter'>  <p className='flecha'>←</p></div>  </Link>
                </div>
            </section>
        </React.Fragment>
    );
}
export default OldWebUno;